import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PageConfigService } from 'src/app/page-config.service';
import {
  Component,
  OnInit
} from '@angular/core';
import {
  GrantPassword
} from '../models/api_models/grantPassword';
import {
  AutorizationService
} from '../api/autorization.service';
import {
  ActivatedRoute,
  Router
} from '@angular/router';
import {
  PublicService
} from '../api/public.service';
import {
  Token
} from '../models/api_models/token';
import {
  NotifiactionService
} from '../services/notifiaction.service';

@Component({
  selector: 'app-user-login-form',
  templateUrl: './user-login-form.component.html',
  styleUrls: ['./user-login-form.component.scss']
})
export class UserLoginFormComponent implements OnInit {

  formUser: GrantPassword;
  _isTry: boolean = false;
  constructor(private route: ActivatedRoute, private formBuilder: FormBuilder, private translate: TranslateService, public snackBar: MatSnackBar, private PageConfigService : PageConfigService, private autorizationService: AutorizationService, private router: Router, private publicService: PublicService, private notificationService: NotifiactionService)
   {
    this.PageConfigService.config.subscribe((x) =>{this.url = x.sub_link});
    this.route.queryParams.subscribe(params => {
         this.stationId = params['station'] ?? null;
     });
    this.formUser = new GrantPassword();
  }

   url
   ip_adress : any;
   hide = true;
   formGroup: FormGroup;
   loading = false;

  stationId!: string | null;
   


  ngOnInit() {
    this.formUser = new GrantPassword();
    this.createForm()
    this.getSubscribe()
    this.getIp()

  }

  createForm() {
    this.formGroup = this.formBuilder.group({
      username: [null, [Validators.required]],
      password: [null, [Validators.required]],
    });
  }



getSubscribe(){
  var url_subscribe = JSON.parse(localStorage.getItem('station_sbscribe')) 
  console.log(url_subscribe)
  if(url_subscribe !== null){
    this.url = url_subscribe
  }
}


removeSubscribe(){
  localStorage.removeItem('station_sbscribe');
}


  // login() {
  //   this._isTry = true;
    
  //   if(this.formUser.username === ""){
  //     this._isTry = false;
  //     return  this.openSnackBar(this.translate.instant('LOGIN.IDENTIFIANT'))
  //   }

  //   if(this.formUser.password === ""){
  //     this._isTry = false;
  //     return  this.openSnackBar(this.translate.instant('LOGIN.PASSWORD'))
  //   }

  //   this.formUser.ip_adress = this.ip_adress.IPv4
  //   this.formUser.city = this.ip_adress.city
  //   this.formUser.country_name = this.ip_adress.country_name
  //   this.formUser.postal = this.ip_adress.postal
  //   this.formUser.state = this.ip_adress.state
  //   this.formUser.url = location.host
  //   this.formUser.connection = window.navigator.userAgent
    
  //   this.autorizationService.login(this.formUser).subscribe(
  //     response => {
  //       this._isTry = false;
  //       // console.log(response);
  //       if (( < Token > response).access_token != undefined) {
  //         this.notificationService.showNewSnackBar(this.translate.instant('LOGIN.HELLO'))
  //         this.publicService.forceClearStation()
  //         this.router.navigate(['/']).then(ok => {
  //            window.location.reload();
  //         });

  //       } else {
  //         this.notificationService.showNewSnackBar(this.translate.instant('LOGIN.ERROR'))
  //       }
  //     },
  //     error => {
  //       this._isTry = false;
  //       console.log(error)
  //       this.openSnackBar(error.error.message)
  //     }
  //   );
  // }


  openSnackBar(message: string) {
    this.snackBar.open(message, "X", {
      panelClass: ['sucess-snackbar'],
      duration: 5000,
    });
  }


getIp(){
  this.autorizationService.getIP().subscribe(
    data => {

      console.log(data)
      this.ip_adress = data
    },
    err => {
      console.log(err)
    });

  }




  getErrorUsername() {
    return this.formGroup.get('username').hasError('required') ? 'Identifiant requis' : '';
  }

  getErrorPassword() {
    return this.formGroup.get('password').hasError('required') ? 'Mot de passe requis' : '';
  }

  get f() { return this.formGroup.controls; }



  // login
  signIn() {

    console.log(this.formGroup.value)
    // this.submitted = true;
    if (this.formGroup.invalid) {
      return;
    }
    this.loading = true;

    this.formUser.username = this.formGroup.value.username
    this.formUser.password = this.formGroup.value.password

    this.autorizationService.login(this.formUser).subscribe(
      response => {
        this._isTry = false;
        // console.log(response);
        if (( < Token > response).access_token != undefined) {
          this.notificationService.showNewSnackBar(this.translate.instant('LOGIN.HELLO'))
          this.publicService.forceClearStation()
          this.router.navigate(['/'], { queryParams: { station: this.stationId } } ).then(ok => {
             window.location.reload();
          });

        } 
        // else {

        //   // this.openSnackBar(error.error.message)
        //   // this.notificationService.showNewSnackBar(this.translate.instant('LOGIN.ERROR'))
        // }
      },
      error => {
        this._isTry = false;
        console.log(error)
        this.openSnackBarError(error.error.message)
      }
    );

  }

  openSnackBarError(message: string) {
    this.snackBar.open(message, "X", {
      panelClass: ['error-snackbar'],
      duration: 20000,
    });
  }



}